"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const render_icon_1 = __importDefault(require("../../icons/render-icon"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const table_1 = require("./table");
const paddings = {
    small: "sm",
    medium: 12,
    large: "md",
};
const useStyles = (0, create_use_styles_1.default)(({ colors, spacing, typography }) => ({
    cell: ({ align, selectable, size, sticky }) => ({
        "position": sticky ? "sticky" : undefined,
        "left": sticky ? (selectable ? spacing(40) : 0) : undefined,
        "padding": spacing(paddings[size], "sm"),
        "fontSize": typography.small.fontSize,
        "textAlign": align,
        "backgroundClip": "padding-box",
        "backgroundColor": "inherit",
        "&:first-child": {
            paddingLeft: spacing("md"),
        },
        "&:last-child": {
            right: sticky ? 0 : undefined,
            left: sticky ? "auto" : undefined,
            paddingRight: spacing("md"),
        },
        "& svg.unsorted-icon": {
            color: colors.gray,
        },
    }),
    icon: {
        marginLeft: spacing(12),
    },
    wrapper: ({ align }) => ({
        display: "grid",
        gridTemplateColumns: "minmax(min-content, max-content) auto",
        alignItems: "center",
        justifyContent: align,
    }),
}));
exports.TableCell = react_1.default.forwardRef(function TableCell({ align = "left", children, className, icon, sticky = false, ...props }, ref) {
    const { parent } = (0, react_1.useContext)(table_1.TableSectionContext);
    const { selectable, size } = (0, react_1.useContext)(table_1.TableContext);
    const classes = useStyles({ align, selectable, size, sticky });
    const Component = parent === "TableHead" ? "th" : "td";
    return (react_1.default.createElement(Component, { ref: ref, className: (0, classnames_1.default)(classes.cell, className), ...props }, icon ? (react_1.default.createElement("div", { className: classes.wrapper },
        children,
        (0, render_icon_1.default)(icon, classes.icon))) : (children)));
});
exports.default = react_1.default.memo(exports.TableCell);
//# sourceMappingURL=data:application/json;base64,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